import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { queryClient } from '@api/queryClient';
import { Question } from 'types/question.types';
import {
  addEventQuestionnaireQuestion,
  AddEventQuestionnaireQuestionResult
} from '@event-editor/api/questionnaire/addEventQuestionnaireQuestion';
import { eventEditorQueryKeys } from '@event-editor/queryKeys';

interface AddQuestionVariables {
  eventId: number;
  question: Question;
  questionsLength: number;
}

export const useAddQuestionMutation = (
  onError: () => void
): UseMutationResult<AddEventQuestionnaireQuestionResult, Error, AddQuestionVariables> => {
  return useMutation({
    mutationFn: (variables: AddQuestionVariables) =>
      addEventQuestionnaireQuestion({
        eventId: variables.eventId,
        question: {
          ...variables.question,
          sort: variables.questionsLength,
          shownBefore: true
        }
      }),
    onError,
    onSuccess: (result, variables) => {
      queryClient.invalidateQueries({
        queryKey: eventEditorQueryKeys.event(variables.eventId)
      });
      // TODO: Invalidate the guest queries here once they are implemented
    }
  });
};
